export const lightTheme = {
  name: 'light',

  primaryColor: '#B8A9C9',
  primaryDark: '#9A86B3',
  secondaryColor: '#D4C8E0',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#B8A9C9',

  bgPrimary: '#ffffff',
  bgSecondary: '#F9F7FC',
  bgTertiary: '#F0EBF7',

  background: '#F0EBF7',
  cardBackground: '#ffffff',
  hoverBackground: '#F5F1FA',

  textPrimary: '#2D1F3D',
  textSecondary: '#4A3A5C',
  textMuted: '#6B5A7B',

  borderColor: '#D4C8E0',

  shadow:
    '0 1px 3px 0 rgba(184, 169, 201, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(184, 169, 201, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#A897BC', // --primary-hover
  primaryStrong: '#7A6490', // --primary-strong (deep lavender, gradient endpoint)
  accentColor: '#9A86B3', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(184, 169, 201, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(184, 169, 201, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(184, 169, 201, 0.12)', // --shadow-soft

  primaryLight: 'rgba(184, 169, 201, 0.14)',
  unreadBackground: 'rgba(184, 169, 201, 0.06)',
  messageBubbleBg: '#F5F1FA',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  primaryColor: '#B8A9C9',
  primaryDark: '#9A86B3',
  secondaryColor: '#D4C8E0',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#D4C8E0',

  bgPrimary: '#12101A',
  bgSecondary: '#1F1828',
  bgTertiary: '#2D1F3D',

  background: '#12101A',
  cardBackground: '#1F1828',
  hoverBackground: '#2D1F3D',

  textPrimary: '#F0EBF7',
  textSecondary: '#D4C8E0',
  textMuted: '#B8A9C9',

  borderColor: '#4A3A5C',

  shadow:
    '0 1px 3px 0 rgba(184, 169, 201, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(184, 169, 201, 0.35)',

  primaryHover: '#CEC2DC', // --primary-hover
  primaryStrong: '#E8DCFF', // --primary-strong (bright lavender, gradient endpoint)
  accentColor: '#D4C8E0', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(184, 169, 201, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(184, 169, 201, 0.35)', // --shadow-xl
  shadowSoft: 'rgba(184, 169, 201, 0.2)', // --shadow-soft

  primaryLight: 'rgba(184, 169, 201, 0.3)',
  unreadBackground: 'rgba(184, 169, 201, 0.16)',
  messageBubbleBg: '#2D1F3D',
  messageReceivedBg: '#3A2850',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
